module.exports = __webpack_public_path__ + "static/media/widget2Logo.20f0cfca.png";